import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

function formatErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Tanya.");
      nav("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <p className="font-serif text-3xl">Qissa<span className="text-accent">.</span>Co</p>
          <p className="text-muted2 text-sm mt-2 uppercase tracking-[0.3em]">Studio Admin</p>
        </div>
        <form onSubmit={submit} className="rounded-xl border border-border bg-surface p-8 space-y-6" data-testid="admin-login-form">
          <div>
            <label className="text-xs uppercase tracking-widest text-muted2">Email</label>
            <input
              type="email" data-testid="login-email"
              className="w-full bg-transparent border-b border-border focus:border-accent outline-none py-3 text-ink transition-colors"
              value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@qissa.co"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-muted2">Password</label>
            <input
              type="password" data-testid="login-password"
              className="w-full bg-transparent border-b border-border focus:border-accent outline-none py-3 text-ink transition-colors"
              value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
            />
          </div>
          <button
            type="submit" disabled={loading} data-testid="login-submit"
            className="w-full rounded-full bg-accent text-bg py-3 font-medium hover:bg-accent-hover transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
